import React from 'react'

import { IoIosClose } from 'react-icons/io'

import { Box, Flex, IconButton } from '@chakra-ui/react'

interface AssociatedDeviceIProps {
  name: string
  onClick: () => void
}

export const AssociatedDevice = ({ name, onClick }: AssociatedDeviceIProps) => {
  return (
    <Flex
      alignItems='center'
      bg='#FDFDFD'
      border='1px solid #E2E2E2'
      borderRadius='10px'
      h='48px'
      justifyContent='space-between'
      px='16px'
      py='8px'
    >
      <Box color='black' fontSize='14px' fontWeight={400}>
        {name}
      </Box>
      <IconButton
        aria-label='Remove'
        bg='#FDFDFD'
        onClick={onClick}
        size='24px'
      >
        <IoIosClose color='black' size={24} />
      </IconButton>
    </Flex>
  )
}
